import React from 'react';
import { Link } from 'react-router-dom';
import Footer_logo from '../../assets/images/Logo.svg';
import footer_1 from '../../assets/images/svg/header/Insta.svg';
import footer_2 from '../../assets/images/svg/header/Fb.svg';
import footer_3 from '../../assets/images/svg/header/Twiter.svg';
import footer_4 from '../../assets/images/svg/header/Pintrest.svg';
import footer_5 from '../../assets/images/footer-icon/footer-one-6.svg';
import footer_6 from '../../assets/images/footer-icon/footer-one-7.svg';
import footer_7 from '../../assets/images/footer-icon/footer-one-8.svg';
import footer_8 from '../../assets/images/footer-icon/footer-one-9.svg';
import footer_9 from '../../assets/images/footer-icon/footer-one-10.svg';
import footer_10 from '../../assets/images/footer-icon/footer-one-1.svg';
import footer_11 from '../../assets/images/footer-icon/footer-one-2.svg';
import footer_12 from '../../assets/images/footer-icon/footer-one-3.svg';
import footer_13 from '../../assets/images/footer-icon/footer-one-4.svg';
import footer_14 from '../../assets/images/footer-icon/footer-one-5.svg';
import footer_15 from '../../assets/images/svg/footer-two/footer-two-mail.svg';
import footer_16 from '../../assets/images/svg/footer-two/footer-two-address.svg';
import footer_17 from '../../assets/images/svg/footer-two/footer-two-call.svg';

const Footer5 = () => {
  return (
    <>
      <>
        <div className="footer-section-five">
          <div className="container">
            <div className="row gutter-y-30">
              <div className="col-lg-3">
                <div className="footer-about-five">
                  <div className="footer-logo-five">
                    <Link to="/">
                      <img src={Footer_logo}alt="logo" />
                    </Link>
                  </div>
                  <p className="lead">
                    Uniqo offers full range of consultancy &amp; training for data
                    consultation strategic ways for business.
                  </p>
                  <ul className="footer-social-media-five">
                    <li>
                      <Link to="https://www.instagram.com/">
                        <img src={footer_1} alt="icon" />
                      </Link>
                    </li>
                    <li>
                      <Link to="https://www.facebook.com/">
                        <img src={footer_2} alt="icon" />
                      </Link>
                    </li>
                    <li>
                      <Link to="https://x.com/">
                        <img src={footer_3} alt="icon" />
                      </Link>
                    </li>
                    <li>
                      <Link to="https://www.pinterest.com/">
                        <img src={footer_4} alt="icon" />
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="footer-widget-two">
                  <h4>Pages</h4>
                  <ul className="footer-menu-two">
                    <li>
                      <img
                        src={footer_5}
                        alt="icon"
                      />
                      <Link to="/Aboutus">About</Link>
                    </li>
                    <li>
                      <img
                        src={footer_6}
                        alt="icon"
                      />
                      <Link to="/Careers">Career </Link>
                    </li>
                    <li>
                      <img
                        src={footer_7}
                        alt="icon"
                      />
                      <Link to="/Aboutus">Applications</Link>
                    </li>
                    <li>
                      <img
                        src={footer_8}
                        alt="icon"
                      />
                      <Link to="/Contact">Contact Us</Link>
                    </li>
                    <li>
                      <img
                        src={footer_9}
                        alt="icon"
                      />
                      <Link to="/Portfolio">Case Studies</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="footer-widget-two">
                  <h4>Services</h4>
                  <ul className="footer-menu-two">
                    <li>
                      <img
                        src={footer_10}
                        alt="icon"
                      />
                      <Link to="/ServiceDetails">Financial Analysis</Link>
                    </li>
                    <li>
                      <img
                        src={footer_11}
                        alt="icon"
                      />
                      <Link to="/ServiceDetails">Work organization</Link>
                    </li>
                    <li>
                      <img
                        src={footer_12}
                        alt="icon"
                      />
                      <Link to="/ServiceDetails">Digital Marketing</Link>
                    </li>
                    <li>
                      <img
                        src={footer_13}
                        alt="icon"
                      />
                      <Link to="/ServiceDetails">Innovation space</Link>
                    </li>
                    <li>
                      <img
                        src={footer_14}
                        alt="icon"
                      />
                      <Link to="/ServiceDetails">Risk Advisory</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="footer-widget-contact">
                  <h4>Contact Us</h4>
                  <ul className="footer-location-four">
                    <li>
                      <span>
                        <img
                          src={footer_15}
                          alt="icon"
                        />
                      </span>
                      <Link to="mailto:needhelp@company.com">needhelp@company.com</Link>
                    </li>
                    <li>
                      <span>
                        <img
                          src={footer_16}
                          alt="icon"
                        />
                      </span>
                      <p>135 klf, Hotland, USA</p>
                    </li>
                    <li>
                      <span>
                        <img
                          src={footer_17}
                          alt="icon"
                        />
                      </span>
                      <Link to="telto:1-888-452-1505">1-888-452-1505</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-8 ms-auto">
                <div className="newslatter-five">
                  <h4>Get in touch</h4>
                  <form action="#">
                    <input
                      type="email"
                      name="email"
                      placeholder="enter your email"
                      className="form-control"
                    />
                    <button type="submit" className="btn btn-primary btn-theme">
                      Subscribe <span>+</span>
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-copyright text-center">
          <p>© Copyright@&nbsp;Uniqo&nbsp;All rights reserved</p>
        </div>
      </>

    </>
  )
}

export default Footer5
